import { render, staticRenderFns } from "./MobileLanguagePicker.vue?vue&type=template&id=681af68c&lang=html&"
import script from "./MobileLanguagePicker.vue?vue&type=script&lang=js&"
export * from "./MobileLanguagePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports